"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntroducingCard = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var currency_1 = require("@nerdwallet/currency");
var nerdwallet_plus_logo_1 = require("../../nerdwallet-plus-logo");
var nerdwallet_plus_drawer_module_css_1 = __importDefault(require("../nerdwallet-plus-drawer.module.css"));
var IntroducingCard = function () {
    return (react_1.default.createElement(currency_1.Box, { padding: 3, className: nerdwallet_plus_drawer_module_css_1.default.introducingCard, display: "flex", flexDirection: "column", marginTop: { desktop: 3, mobile: 5 } },
        react_1.default.createElement(currency_1.Type, { className: (0, classnames_1.default)(nerdwallet_plus_drawer_module_css_1.default.margin2, nerdwallet_plus_drawer_module_css_1.default.bold) }, "INTRODUCING"),
        react_1.default.createElement(currency_1.Box, null,
            react_1.default.createElement(nerdwallet_plus_logo_1.NerdWalletPlusLogo, { width: 212, height: 31 })),
        react_1.default.createElement(currency_1.Box, { width: 90 },
            react_1.default.createElement(currency_1.Type, { className: (0, classnames_1.default)(nerdwallet_plus_drawer_module_css_1.default.margin3, nerdwallet_plus_drawer_module_css_1.default.bold) }, "Earn $100 in rewards when you open an eligible bank account"))));
};
exports.IntroducingCard = IntroducingCard;
